import React from 'react';
import { WalletMultiButton } from '@solana/wallet-adapter-react-ui';

const TopBar = () => {
  return (
    <div style={styles.navbar}>
      <div style={styles.left}>DeepMeme</div>
      <div style={styles.right}>
        <WalletMultiButton style={styles.button} />
      </div>
    </div>
  );
};

const styles = {
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: '#6e2fbd', // Purple top bar
    padding: '1rem 2rem',
    fontSize: '1.75rem',
    position: 'sticky',
    top: 0,
    zIndex: 50,
    borderBottom: '1px solid #444',
  },
  left: {
    fontFamily: 'VT323',
    color: '#FAFF00', // Toxic Yellow Logo
    fontSize: '2rem',
  },
  right: {
    display: 'flex',
    alignItems: 'center',
  },
  button: {
    backgroundColor: '#6e2fbd',
    border: '2px solid #00FFFF', // Cyan outline
    color: '#00FFFF',
    padding: '0.5rem 1rem',
    fontSize: '1rem',
    fontFamily: 'inherit',
    borderRadius: '4px',
  },
};

export default TopBar;
